import { getScreenWidth } from '../../utils/dom'

const distance = 10
const bodyPadding = 10
let overlap = 40

function getScrollTop() {
  return (
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0
  )
}

function getScrollLeft() {
  return (
    window.pageXOffset ||
    document.documentElement.scrollLeft ||
    document.body.scrollLeft ||
    0
  )
}

function getTipMaxWidth() {
  const screenWidth = getScreenWidth()
  return typeof document !== 'undefined' ? screenWidth - bodyPadding * 2 : 1000
}

export function getPosition(
  tip: any,
  target: any,
  state: any,
  align: string,
  type: string,
  fixed?: boolean,
) {
  const screenWidth = getScreenWidth()
  let left = -100000
  let top
  let bottom = ''

  if (tip && state.showTip) {
    // get wrapper left position
    const targetRect = target.getBoundingClientRect()
    const targetLeft = targetRect.left + getScrollLeft()
    const targetRight = targetRect.right + getScrollLeft()

    const tipWidth = Math.min(getTipMaxWidth(), tip.offsetWidth)

    // calculate left if non-mobile
    if (screenWidth >= 768) {
      if (screenWidth >= 1024) {
        overlap = 60
      }
      if (align === 'left') {
        left = targetLeft - overlap
      } else if (align === 'right') {
        left = targetRight - tipWidth + overlap
      }

      // check for right overhand
      const rightOverhang = left + tipWidth + bodyPadding - screenWidth
      if (rightOverhang > 0) {
        left -= rightOverhang
        bottom = 'unset'
      }
    } else {
      bottom = 'unset'
    }

    if (type === 'note') {
      left = 0
      top = 0
      bottom = 'unset'
    } else if (fixed === true) {
      top = targetRect.top - (tip.offsetHeight + distance)
      bottom = 'unset'
    } else {
      top = targetRect.top + getScrollTop() - (tip.offsetHeight + distance)
      bottom = 'unset'
    }
  } else {
    // flash loading off screen
    return {
      left,
      bottom,
    }
  }

  if (left === -100000) {
    return {
      left: 0,
      top,
      bottom,
    }
  } else {
    return {
      left,
      top,
      bottom,
    }
  }
}
